import React from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Hero from '../../components/hero/hero';
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation';
import About3 from '../../components/About3/About3';
import ProjectSection from '../../components/ProjectSection/ProjectSection';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import FunFact from '../../components/FunFact/FunFact';
import TestimonialS2 from '../../components/TestimonialS2/TestimonialS2';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo-5.png'

const HomePage = () => {
    return (
        <div style={{ overflowX: 'hidden' }}>
            <Navbar
                hclass={'wpo-site-header wpo-header-style'}
                Logo={Logo}
                  page={'home'}
                col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                col2={'col-lg-5 col-md-6 col-6'}
                col3={'col-lg-5 col-md-1 col-1'}
                col4={'col-lg-2 col-md-2 col-2'}
            />
            <Hero />
            <ScrollTextAnimation />
            <About3 hclass={'wpo-about-section-s3'} />
            <ProjectSection hclass={'wpo-project-section section-padding'} />
            <ServiceSection hclass={'wpo-service-section'} />
            <FunFact hclass={'wpo-funfact-section'} />
            <TestimonialS2 hclass={'wpo-testimonial-section-s2'} />
            <Footer />
            <Scrollbar />
        </div>
    );
};

export default HomePage;
